import React, { useState } from "react";
import {
  getChatHistory,
  getConversationMetadata,
  getConversationStatus,
  statusTypes,
} from "./conversationHistorytools";
import Chat from "../components/WidgetInterface/Chat/Chat";
import { chain } from "ramda";
import { createUseStyles } from "react-jss";
import { eventToMessages } from "../components/Panels";

const useStyles = createUseStyles((theme) => ({
  chat: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "rgba(70, 71, 117, 0.08)",
    padding: "20px 20px 10px 20px",
    width: "35%",
    minWidth: "420px",
  },
  title: {
    marginLeft: "10px",
    lineHeight: "24px",
    fontSize: "14px",
    textTransform: "capitalize",
  },
  textInput: {
    display: "block",
    resize: "none",
    overflow: "hidden",
    lineHeight: "24px",
    color: theme.textColor,
    backgroundClip: "padding-box",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", Helvetica,Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important',
    fontWeight: "400",
    fontSize: "14px",
    borderRadius: "30px",
    border: "0",
    boxSizing: "border-box",
    height: "50px",
    padding: "13px",
    marginTop: "4px",
    "&::placeholder": { fontSize: "14px" },
    "&:focus": {
      outline: "0 !important",
    },
  },
  textArea: {},
  userContext: {
    background: "rgba(70, 71, 117, 0.1)",
    height: "85px",
    padding: {
      top: "20px",
      left: "20px",
      right: "20px",
    },
  },
}));

const parseHistory = chain(eventToMessages);

const UserContext = ({ selectedConversation, styles }) => {
  selectedConversation.metadata = getConversationMetadata(
    selectedConversation.conversationHistory
  );
  return Object.keys(selectedConversation.metadata).map((key) => (
    <p key={key} className={styles.title}>
      <strong>{key.replace(/([A-Z])/g, " $1")}: </strong>
      {selectedConversation.metadata[key].replace(/([A-Z])/g, " $1")}
    </p>
  ));
};

export default ({ sendUtterance, selectedConversation }) => {
  const [agentTextMessage, setAgentTextMessage] = useState("");
  const [triggerAgentScrollDown, setTriggerAgentScrollDown] = useState(false);
  const styles = useStyles();

  return (
    <div className={styles.chat}>
      <div className={styles.userContext}>
        {selectedConversation ? (
          <UserContext
            selectedConversation={selectedConversation}
            styles={styles}
          />
        ) : (
          ""
        )}
      </div>
      <Chat
        isAgent={true}
        onResultsClick={() => {}}
        onMapClick={() => {}}
        messages={
          selectedConversation
            ? parseHistory(
                getChatHistory(selectedConversation.conversationHistory)
              )
            : []
        }
        isThinking={false}
        triggerAgentScrollDown={triggerAgentScrollDown}
        transcribedText={""}
        numberOfIterationsToShow={-1}
        sendEvent={() => {}}
        showAvatar={false}
        onSuggestionClick={() => {}}
        customAvatar={false}
        shouldTruncate={false}
        hyroLogo={false}
      />
      <textarea
        className={styles.textInput}
        placeholder={
          selectedConversation &&
          getConversationStatus(selectedConversation.conversationHistory)[0] ===
            statusTypes.ENDED
            ? "This conversation has ended"
            : "Type here to reply"
        }
        value={agentTextMessage}
        onChange={(event) => setAgentTextMessage(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter" && event.shiftKey === false) {
            setTriggerAgentScrollDown(!triggerAgentScrollDown);
            event.preventDefault();
            if (event.target.value.trim()) {
              setAgentTextMessage("");
              sendUtterance(event.target.value);
            }
          }
        }}
        disabled={
          !!(
            selectedConversation &&
            getConversationStatus(
              selectedConversation.conversationHistory
            )[0] === statusTypes.ENDED
          )
        }
      />
    </div>
  );
};
